import React, { useEffect, useState } from "react";
import Card from "react-bootstrap/Card";
import { FaArrowTrendUp, FaArrowTrendDown } from "react-icons/fa6";
import Dettagli from "./DettagliManVen";
import axios from "axios";

function WithHeaderStyledExample() {
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  const [quantityOrdered2023, setQuantityOrdered2023] = useState(0);
  const [quantityOrdered2024, setQuantityOrdered2024] = useState(0);
  const [percentuale, setPercentuale] = useState("");

  const [mancataVenditaMedia, setMancataVenditaMedia] = useState({});
  const [mancataVenditaAttuale, setMancataVenditaAttuale] = useState({});
  const [percentualeValore, setPercentualeValore] = useState("");
  const [percentualeQta, setPercentualeQta] = useState("");
  const [percentualeNumCli, setPercentualeNumCli] = useState("");

  const [showModal, setShowModal] = useState(false);

  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);

 const formatToEuro = (amount) =>
    new Intl.NumberFormat("it-IT", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount || 0);

  const getDateRange = () => {
    const today = new Date();
    const currentMonth = today.getMonth() + 1;
    const currentYear = today.getFullYear();
    const lastYear = currentYear - 1;
    const pad = (n) => (n < 10 ? "0" + n : n);
    const formattedMonth = pad(currentMonth);
    const formattedDay = pad(today.getDate());

    return {
      currentDateRange: `01/${formattedMonth}/${currentYear} - ${formattedDay}/${formattedMonth}/${currentYear}`,
      lastYearDateRange: `01/${formattedMonth}/${lastYear} - ${formattedDay}/${formattedMonth}/${lastYear}`
    };
  };

  const { currentDateRange, lastYearDateRange } = getDateRange();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get("./dati_dashboard.json");
        const { mese, mancata_vendita } = res.data.TP;

        const entry2023 = mese.find((e) => e.anno === "2025");
        const entry2024 = mese.find((e) => e.anno === "2026");
        if (entry2023) setQuantityOrdered2023(entry2023.valore_ordinato);
        if (entry2024) setQuantityOrdered2024(entry2024.valore_ordinato);

        if (entry2023 && entry2024) {
          const change = ((entry2024.valore_ordinato - entry2023.valore_ordinato) / entry2023.valore_ordinato) * 100;
          setPercentuale(change.toFixed(2));
        }

        if (mancata_vendita) {
          setMancataVenditaMedia(mancata_vendita.media);
          setMancataVenditaAttuale(mancata_vendita.attuale);
          const calcPerc = (curr, med) => med ? ((curr - med) / med * 100).toFixed(2) : "0";
          setPercentualeValore(calcPerc(mancata_vendita.attuale.valore, mancata_vendita.media.valore));
          setPercentualeQta(calcPerc(mancata_vendita.attuale.qta, mancata_vendita.media.qta));
          setPercentualeNumCli(calcPerc(mancata_vendita.attuale.num_cli, mancata_vendita.media.num_cli));
        }
        setIsLoading(false);
      } catch (error) {
        setIsError(true);
      }
    };
    fetchData();
  }, []);

  const renderTrend = (perc, inverse = false) => {
    if (perc === "") return null;
    const val = parseFloat(perc);
    const isNeg = val < 0;
    const color = inverse ? (val > 0 ? "#dc3545" : "#198754") : (isNeg ? "#dc3545" : "#198754");
    return (
      <span className="fw-bold d-flex align-items-center gap-1 text-nowrap" style={{ color: color, fontSize: "0.75rem" }}>
        {perc}% {isNeg ? <FaArrowTrendDown /> : <FaArrowTrendUp />}
      </span>
    );
  };

  return (
    <>
      <Card
        className="card ombra ordini-ora card-home hover-effect border-0 tp-summary-card tp-orders-detail-card"
        style={{ borderRadius: "15px", padding: "1.2rem", cursor: 'pointer' }}
        onClick={handleShowModal}
      >
        <Card.Body className="p-0 tp-summary-body"> {/* Padding rimosso qui per gestirlo nel wrapper scrollabile */}
          
          {/* WRAPPER SCROLLABILE: Si attiva sotto i 300px */}
          <div className="responsive-scroll-container">
            <div style={{ minWidth: "260px" }}> {/* Impedisce il collasso degli elementi interni */}
              
              {/* Header */}
              <div className="mb-3">
                <p className="text-title fw-bold mt-3 mb-3 text-nowrap" style={{ fontSize: "0.85rem", letterSpacing: "0.5px" }}>
                  DETTAGLI ORDINI
                </p>
                <small className="text-muted text-nowrap d-block" style={{ fontSize: "0.6rem" }}>
                  {currentDateRange} vs {lastYearDateRange}
                </small>
              </div>

              {/* Confronto Annuale */}
              <div className="d-flex flex-column gap-2 mb-3">
                <div className="d-flex justify-content-between text-dark align-items-center flex-wrap gap-1">
                  <span className="fw-bold small text-nowrap text-dark ">TOTALE 2026</span>
                  <div className="d-flex align-items-center gap-2">
                    <span className="fw-bold mb-0 " style={{fontSize: '1.1rem'}}>{formatToEuro(quantityOrdered2024)}</span>
                    {renderTrend(percentuale)}
                  </div>
                </div>
                <div className="d-flex justify-content-between align-items-center">
                  <span className="text-secondary small fw-bold text-dark">TOTALE 2025</span>
                  <span className="text-secondary small fw-bold">{formatToEuro(quantityOrdered2023)}</span>
                </div>
              </div>

              {/* Sezione Mancata Vendita */}
              <div className="p-2 rounded tp-focus-box" style={{ backgroundColor: "#f8f9fa", border: "1px solid #e9ecef" }}>
                <p className="text-center fw-bold mb-2 text-uppercase" style={{ fontSize: "0.65rem", color: "#495057" }}>
                  Focus Mancata Vendita
                </p>

                {/* Tabella stilizzata per allineamento perfetto */}
                {[
                  { label: "Valore", attuale: formatToEuro(mancataVenditaAttuale.valore), media: formatToEuro(mancataVenditaMedia.valore), trend: percentualeValore },
                  { label: "Clienti", attuale: mancataVenditaAttuale.num_cli, media: mancataVenditaMedia.num_cli, trend: percentualeNumCli },
                  { label: "Quantità", attuale: mancataVenditaAttuale.qta, media: mancataVenditaMedia.qta, trend: percentualeQta }
                ].map((row, i) => (
                  <div key={i} className={`d-flex justify-content-between align-items-center py-1 ${i !== 0 ? 'border-top tp-focus-divider' : ''}`}>
                    <div className="d-flex flex-column" style={{ width: '33%' }}>
                      <span className="text-muted text-uppercase fw-bold x-small-font">{row.label}</span>
                      <span className="fw-bold small text-nowrap">{row.attuale}</span>
                    </div>
                    <div className="text-center d-flex flex-column" style={{ width: '33%' }}>
                      <span className="text-muted text-uppercase x-small-font">Media</span>
                      <span className="small text-dark text-nowrap">{row.media}</span>
                    </div>
                    <div className="d-flex flex-column align-items-end" style={{ width: '33%' }}>
                      <span className="text-muted text-uppercase x-small-font">Trend</span>
                      {renderTrend(row.trend, true)}
                    </div>
                  </div>
                ))}
              </div>

            </div>
          </div>
        </Card.Body>
      </Card>

      <style>{`
  .tp-orders-detail-card {
    overflow: hidden !important;
  }

  .tp-orders-detail-card .tp-summary-body {
    width: 100% !important;
    height: 100% !important;

    overflow-y: auto !important;
    overflow-x: hidden !important;

    scrollbar-width: none !important;
    -ms-overflow-style: none !important;
  }

  .tp-orders-detail-card .tp-summary-body::-webkit-scrollbar {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }

  .responsive-scroll-container {
    width: 100%;

    overflow-x: auto !important;
    overflow-y: visible !important;

    padding: 5px;

    scrollbar-width: none !important;
    -ms-overflow-style: none !important;
  }

  .responsive-scroll-container::-webkit-scrollbar {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }

  .x-small-font {
    font-size: 0.55rem !important;
  }

  .text-nowrap {
    white-space: nowrap;
  }

  @media (max-width: 320px) {
    .ombra.ordini-ora {
      max-width: 300px;
    }
  }


  /* =========================================================
     TECHNOPARTS LIGHT — DETTAGLI ORDINI
     SOLO LA CARD. IL MODALE RIMANE DARK.
     ========================================================= */

  .tp-orders-detail-card {
    color: #252a31 !important;
  }

  .tp-orders-detail-card .tp-summary-body,
  .tp-orders-detail-card .responsive-scroll-container {
    color: #252a31 !important;
  }

  /* Titolo rosso Technoparts */
  .tp-orders-detail-card .text-title {
    color: #b81f25 !important;
  }

  /* Data e testi secondari */
  .tp-orders-detail-card .text-muted,
  .tp-orders-detail-card .text-secondary {
    color: #6f7680 !important;
  }

  /* Tutti i vecchi text-light / text-white della card diventano scuri */
  .tp-orders-detail-card .text-light,
  .tp-orders-detail-card .text-white,
  .tp-orders-detail-card .text-white-50,
  .tp-orders-detail-card .text-dark {
    color: #252a31 !important;
  }

  /* Testi normali e valori */
  .tp-orders-detail-card p,
  .tp-orders-detail-card small,
  .tp-orders-detail-card span {
    color: #343a43;
  }

  .tp-orders-detail-card .fw-bold {
    color: #252a31;
  }

  /* Box Focus Mancata Vendita */
  .tp-orders-detail-card .tp-focus-box {
    background:
      rgba(255, 255, 255, 0.55) !important;

    border:
      1px solid rgba(31, 38, 48, 0.09) !important;

    box-shadow:
      inset 0 1px 0 rgba(255, 255, 255, 0.72);
  }

  .tp-orders-detail-card .tp-focus-box p {
    color: #343a43 !important;
  }

  .tp-orders-detail-card .tp-focus-box .x-small-font {
    color: #747b85 !important;
  }

  .tp-orders-detail-card .tp-focus-box .small {
    color: #343a43 !important;
  }

  /* Divisori: niente più bianco */
  .tp-orders-detail-card .tp-focus-divider {
    border-top:
      1px solid rgba(31, 38, 48, 0.09) !important;
  }

  /* I trend DEVONO mantenere verde/rosso */
  .tp-orders-detail-card span[style*="#198754"] {
    color: #198754 !important;
  }

  .tp-orders-detail-card span[style*="#dc3545"] {
    color: #dc3545 !important;
  }

  /* =========================================================
   MANCATA VENDITA MODAL — LIQUID GLASS V2
   ========================================================= */

/* SFONDO DIETRO: QUASI OPACO */
.modal-backdrop.show {
  opacity: 0.9 !important;
  background: #07090d !important;

  /* niente effetto nebbia esagerato */
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
}

/* =========================================================
   FINESTRA
   ========================================================= */

.modale-test {
  padding: 18px !important;
}

.modale-test .modal-dialog {
  width: min(1380px, calc(100vw - 36px)) !important;
  max-width: 1380px !important;

  margin: 0 auto !important;
}

.modale-test .modal-content {
  position: relative;

  width: 100% !important;

  max-height: calc(100dvh - 36px) !important;

  overflow: hidden !important;

  color: #f5f6f8 !important;

  /*
    Glass più scuro e compatto:
    molta trasparenza visiva ma POCO blur.
  */
  background:
    radial-gradient(
      circle at 0% 0%,
      rgba(184, 31, 37, 0.15),
      transparent 32%
    ),
    linear-gradient(
      145deg,
      rgba(39, 42, 49, 0.92),
      rgba(22, 24, 29, 0.94)
    ) !important;

  border:
    1px solid rgba(255, 255, 255, 0.11) !important;

  border-radius: 24px !important;

  box-shadow:
    0 30px 75px rgba(0, 0, 0, 0.58),
    inset 0 1px 0 rgba(255, 255, 255, 0.09),
    inset 0 -1px 0 rgba(0, 0, 0, 0.18) !important;

  /* POCO blur */
  backdrop-filter:
    blur(8px)
    saturate(115%) !important;

  -webkit-backdrop-filter:
    blur(8px)
    saturate(115%) !important;
}

/* riflesso rosso superiore */
.modale-test .modal-content::before {
  content: "";

  position: absolute;
  top: 0;
  left: 28px;

  width: 35%;
  height: 1px;

  background:
    linear-gradient(
      90deg,
      #dc3038,
      transparent
    );

  pointer-events: none;

  z-index: 5;
}

/* =========================================================
   HEADER
   ========================================================= */

.modale-test .modal-header {
  flex: 0 0 auto;

  padding:
    20px
    23px
    14px !important;

  background:
    rgba(255, 255, 255, 0.018) !important;

  border: 0 !important;

  border-bottom:
    1px solid rgba(255, 255, 255, 0.065) !important;
}

.modale-test .modal-title,
.modale-test .text-modal {
  color: #fff !important;

  background: transparent !important;

  font-size: 1.05rem !important;

  font-weight: 850 !important;

  letter-spacing: 0.055em;

  text-transform: uppercase;
}

/* =========================================================
   BODY
   ========================================================= */

.modale-test .modal-body {
  padding:
    16px
    18px
    18px !important;

  background: transparent !important;

  overflow-y: auto !important;
  overflow-x: hidden !important;

  /* SCROLL FUNZIONA MA BARRA INVISIBILE */
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
}

.modale-test .modal-body::-webkit-scrollbar {
  display: none !important;

  width: 0 !important;
  height: 0 !important;
}

/* elimina vecchio bianco bootstrap */
.modale-test .bg-white,
.modale-test .bg-light {
  background: transparent !important;
}

/* =========================================================
   CARD INTERNE
   ========================================================= */

.modale-test .card-modale {
  position: relative;

  color:
    rgba(255, 255, 255, 0.75) !important;

  background:
    linear-gradient(
      145deg,
      rgba(255, 255, 255, 0.07),
      rgba(255, 255, 255, 0.025)
    ) !important;

  border:
    1px solid rgba(255, 255, 255, 0.085) !important;

  border-radius: 17px !important;

  box-shadow:
    0 12px 28px rgba(0, 0, 0, 0.22),
    inset 0 1px 0 rgba(255, 255, 255, 0.055) !important;

  /*
    Qui il glass è appena accennato.
    Non vogliamo l'effetto tutto sfocato.
  */
  backdrop-filter:
    blur(5px)
    saturate(110%) !important;

  -webkit-backdrop-filter:
    blur(5px)
    saturate(110%) !important;

  overflow: hidden !important;
}

.modale-test .card-modale .card-body {
  color:
    rgba(255, 255, 255, 0.72) !important;

  background: transparent !important;
}

.modale-test .card-title,
.modale-test .card-subtitle {
  color: #fff !important;
}

.modale-test .card-text {
  color:
    rgba(255, 255, 255, 0.5) !important;
}

.modale-test .text-dark {
  color:
    rgba(255, 255, 255, 0.86) !important;
}

.modale-test .text-muted {
  color:
    rgba(255, 255, 255, 0.44) !important;
}

/* =========================================================
   CARD CON TABELLE
   SCROLLABILI MA SENZA BARRA
   ========================================================= */

.modale-test .scrollable-list {
  max-height: 430px !important;

  overflow: hidden !important;
}

/*
  È il Card.Body che deve scrollare.
*/
.modale-test .scrollable-list > .card-body {
  height: 100% !important;

  overflow-y: auto !important;
  overflow-x: auto !important;

  scrollbar-width: none !important;
  -ms-overflow-style: none !important;

  overscroll-behavior: contain;
}

/* Chrome / Edge / Safari */
.modale-test
.scrollable-list
> .card-body::-webkit-scrollbar {
  display: none !important;

  width: 0 !important;
  height: 0 !important;
}

/* Anche eventuali wrapper Bootstrap */
.modale-test .table-responsive {
  overflow: auto !important;

  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
}

.modale-test
.table-responsive::-webkit-scrollbar {
  display: none !important;

  width: 0 !important;
  height: 0 !important;
}

/* =========================================================
   TABS
   ========================================================= */

.modale-test .nav-tabs {
  display: flex;

  gap: 5px;

  padding: 4px;

  margin-bottom: 12px !important;

  border:
    1px solid rgba(255, 255, 255, 0.07) !important;

  border-radius: 11px !important;

  background:
    rgba(255, 255, 255, 0.032) !important;
}

.modale-test .nav-tabs .nav-link {
  padding:
    7px
    10px;

  color:
    rgba(255, 255, 255, 0.47) !important;

  background:
    transparent !important;

  border: 0 !important;

  border-radius:
    8px !important;

  font-size: 0.66rem;

  font-weight: 800;

  transition:
    color 0.16s ease,
    background 0.16s ease;
}

.modale-test .nav-tabs .nav-link:hover {
  color:
    rgba(255, 255, 255, 0.84) !important;

  background:
    rgba(255, 255, 255, 0.045) !important;
}

.modale-test .nav-tabs .nav-link.active {
  color: #fff !important;

  background:
    linear-gradient(
      135deg,
      rgba(184, 31, 37, 0.9),
      rgba(145, 18, 24, 0.86)
    ) !important;

  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.10),
    0 6px 16px rgba(184, 31, 37, 0.14);
}

/* =========================================================
   TABELLE
   ========================================================= */

.modale-test .table {
  width: 100%;

  margin: 0 !important;

  color:
    rgba(255, 255, 255, 0.70) !important;

  background:
    transparent !important;
}

.modale-test
.table
> :not(caption)
> *
> * {
  background:
    transparent !important;

  box-shadow:
    none !important;
}

/* HEADER FISSO DURANTE LO SCROLL */
.modale-test .table thead th {
  position: sticky;

  top: 0;

  z-index: 10;

  padding:
    9px
    10px !important;

  color:
    rgba(255, 255, 255, 0.42) !important;

  background:
    #1b1e24 !important;

  border: 0 !important;

  border-bottom:
    1px solid rgba(255, 255, 255, 0.07) !important;

  font-size: 0.60rem;

  font-weight: 850;

  letter-spacing:
    0.055em;

  white-space:
    nowrap;
}

.modale-test .table tbody td {
  padding:
    8px
    10px !important;

  color:
    rgba(255, 255, 255, 0.70) !important;

  background:
    transparent !important;

  border-color:
    rgba(255, 255, 255, 0.045) !important;

  vertical-align: middle;
}

.modale-test .table tbody tr {
  transition:
    background 0.16s ease;
}

.modale-test .table tbody tr:hover td {
  background:
    rgba(255, 255, 255, 0.035) !important;
}

/* valori rossi */
.modale-test
.table
td[style*="#b81f25"],
.modale-test
.table
th[style*="#b81f25"] {
  color:
    #ff5961 !important;
}

/* =========================================================
   GRAFICI
   ========================================================= */

.modale-test .recharts-pie-label-text {
  fill: #fff !important;
}

.modale-test .recharts-legend-item-text {
  color:
    rgba(255, 255, 255, 0.62) !important;
}

.modale-test .recharts-default-tooltip {
  color: #fff !important;

  background:
    #181b20 !important;

  border:
    1px solid rgba(255, 255, 255, 0.10) !important;

  border-radius:
    10px !important;

  box-shadow:
    0 12px 28px
    rgba(0, 0, 0, 0.30);
}

/* =========================================================
   FOOTER
   ========================================================= */

.modale-test .modal-footer {
  flex: 0 0 auto;

  padding:
    8px
    18px !important;

  background:
    rgba(255, 255, 255, 0.018) !important;

  border: 0 !important;

  border-top:
    1px solid rgba(255, 255, 255, 0.06) !important;
}

.modale-test .modal-footer img {
  max-width: 140px;

  height: auto;
}

/* =========================================================
   TABLET
   ========================================================= */

@media (max-width: 991px) {
  .modale-test {
    padding: 10px !important;
  }

  .modale-test .modal-dialog {
    width:
      calc(100vw - 20px) !important;

    max-width:
      none !important;
  }

  .modale-test .flex-card {
    min-width: 100% !important;
  }

  .modale-test .scrollable-list {
    max-height: 390px !important;
  }
}

/* =========================================================
   MOBILE
   ========================================================= */

@media (max-width: 575px) {
  .modale-test {
    padding: 6px !important;
  }

  .modale-test .modal-dialog {
    width:
      calc(100vw - 12px) !important;
  }

  .modale-test .modal-content {
    max-height:
      calc(100dvh - 12px) !important;

    border-radius:
      18px !important;
  }

  .modale-test .modal-header {
    padding:
      14px
      13px
      10px !important;
  }

  .modale-test .modal-title,
  .modale-test .text-modal {
    font-size:
      0.88rem !important;
  }

  .modale-test .modal-body {
    padding:
      10px
      10px
      14px !important;
  }

  .modale-test .nav-tabs {
    flex-wrap:
      nowrap !important;

    overflow-x:
      auto !important;

    scrollbar-width:
      none !important;
  }

  .modale-test
  .nav-tabs::-webkit-scrollbar {
    display:
      none !important;
  }

  .modale-test
  .nav-tabs
  .nav-link {
    white-space:
      nowrap;
  }

  .modale-test .scrollable-list {
    max-height:
      360px !important;
  }

  .modale-test .table {
    font-size:
      0.64rem;
  }

  .modale-test .modal-footer img {
    max-width:
      110px;
  }
}
`}</style>

      <Dettagli showModal={showModal} handleCloseModal={handleCloseModal} />
    </>
  );
}

export default WithHeaderStyledExample;